(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function createOption(value, label) {
    var option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    return option;
  }

  function FitmentFinder(root) {
    this.root = root;
    this.dataUrl = root.dataset.fitmentUrl;
    this.currentSku = (root.dataset.currentSku || '').toUpperCase();
    this.data = null;
    this.products = {};

    var source = root.dataset.productsSource;
    var node = source ? document.getElementById(source) : null;
    if (node) {
      try {
        this.products = JSON.parse(node.textContent || '{}');
      } catch (e) {
        this.products = {};
      }
    }

    this.strings = {
      yearCurrent: root.dataset.yearCurrent || 'present',
      fitYes: root.dataset.fitYes || 'Yes — this lock fits your bike.',
      fitAlt: root.dataset.fitAlt || 'This lock does not fit. You need [sku].',
      fitNone: root.dataset.fitNone || 'Unfortunately there is no Guardian lock for this bike.',
      brandPlaceholder: root.dataset.brandPlaceholder || 'Brand',
      modelPlaceholder: root.dataset.modelPlaceholder || 'Model',
    };

    this.brandSelect = root.querySelector('[data-fitment-brand]');
    this.modelSelect = root.querySelector('[data-fitment-model]');
    this.resultEl = root.querySelector('[data-fitment-result]');

    this.bind();
    this.load();
  }

  FitmentFinder.prototype.bind = function () {
    var self = this;

    if (this.brandSelect) {
      this.brandSelect.addEventListener('change', function () {
        self.onBrandChange();
      });
    }

    if (this.modelSelect) {
      this.modelSelect.addEventListener('change', function () {
        self.onModelChange();
      });
    }
  };

  FitmentFinder.prototype.yearLabel = function (entry) {
    if (!entry.yf && !entry.yt) return '';
    if (entry.yf && !entry.yt) return '(' + entry.yf + ' - ' + this.strings.yearCurrent + ')';
    if (!entry.yf && entry.yt) return '( - ' + entry.yt + ')';
    return '(' + entry.yf + ' - ' + entry.yt + ')';
  };

  FitmentFinder.prototype.modelLabel = function (entry) {
    var years = this.yearLabel(entry);
    return years ? entry.m + ' ' + years : entry.m;
  };

  FitmentFinder.prototype.load = function () {
    var self = this;
    fetch(this.dataUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('load failed');
        return response.json();
      })
      .then(function (data) {
        self.data = data;
        self.populateBrands();
        self.root.classList.add('is-ready');
      })
      .catch(function () {
        self.resultEl.innerHTML = '<p class="fitment-finder__msg">Could not load fitment data.</p>';
      });
  };

  FitmentFinder.prototype.populateBrands = function () {
    if (!this.brandSelect || !this.data) return;
    var self = this;
    this.brandSelect.innerHTML = '';
    this.brandSelect.appendChild(createOption('', this.strings.brandPlaceholder));
    (this.data.brands || []).forEach(function (brand) {
      self.brandSelect.appendChild(createOption(brand, brand));
    });
    this.resetModels(true);
  };

  FitmentFinder.prototype.resetModels = function (disabled) {
    if (!this.modelSelect) return;
    this.modelSelect.innerHTML = '';
    this.modelSelect.appendChild(createOption('', this.strings.modelPlaceholder));
    this.modelSelect.disabled = Boolean(disabled);
  };

  FitmentFinder.prototype.populateModels = function (brand) {
    var self = this;
    var models = (this.data.models[brand] || []).slice();
    this.resetModels(false);
    models.forEach(function (entry, index) {
      self.modelSelect.appendChild(createOption(String(index), self.modelLabel(entry)));
    });
  };

  FitmentFinder.prototype.onBrandChange = function () {
    this.clearResult();
    var brand = this.brandSelect.value;
    if (!brand) {
      this.resetModels(true);
      return;
    }
    this.populateModels(brand);
  };

  FitmentFinder.prototype.onModelChange = function () {
    var brand = this.brandSelect.value;
    var value = this.modelSelect.value;
    if (!brand || value === '') {
      this.clearResult();
      return;
    }
    this.showResult(brand, Number(value));
  };

  FitmentFinder.prototype.clearResult = function () {
    this.resultEl.innerHTML = '';
  };

  FitmentFinder.prototype.showResult = function (brand, index) {
    var entry = (this.data.models[brand] || [])[index];
    if (!entry) return;

    var bike = escapeHtml(brand + ' ' + this.modelLabel(entry));
    var sku = entry.s ? String(entry.s).toUpperCase() : '';

    if (!sku) {
      this.resultEl.innerHTML =
        '<div class="fitment-finder__card fitment-finder__card--none">' +
        '<p class="fitment-finder__bike">' +
        bike +
        '</p>' +
        '<p class="fitment-finder__msg">' +
        escapeHtml(this.strings.fitNone) +
        '</p>' +
        '</div>';
      return;
    }

    if (this.currentSku && sku === this.currentSku) {
      this.resultEl.innerHTML =
        '<div class="fitment-finder__card fitment-finder__card--yes">' +
        '<p class="fitment-finder__bike">' +
        bike +
        '</p>' +
        '<p class="fitment-finder__msg">' +
        escapeHtml(this.strings.fitYes) +
        '</p>' +
        '</div>';
      return;
    }

    var alt = this.products[sku];
    var message = escapeHtml(this.strings.fitAlt.replace('[sku]', sku));
    var link = '';

    if (alt && alt.url) {
      link =
        '<p class="fitment-finder__action"><a class="fitment-finder__link" href="' +
        escapeHtml(alt.url) +
        '">' +
        escapeHtml(alt.title || sku) +
        '</a></p>';
    } else {
      link = '<p class="fitment-finder__sku">' + escapeHtml(sku) + '</p>';
    }

    this.resultEl.innerHTML =
      '<div class="fitment-finder__card fitment-finder__card--alt">' +
      '<p class="fitment-finder__bike">' +
      bike +
      '</p>' +
      '<p class="fitment-finder__msg">' +
      message +
      '</p>' +
      link +
      '</div>';
  };

  function init() {
    document.querySelectorAll('[data-fitment-finder]').forEach(function (root) {
      if (root.dataset.fitmentInitialized) return;
      root.dataset.fitmentInitialized = 'true';
      new FitmentFinder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
